import React from 'react';
import { TextField, Grid } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import daLocale from 'date-fns/locale/da';

function DateSelector({ date, setDate }) {
  return (
    <Grid item xs={12} sm={6}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={daLocale}>
        <DatePicker
          label="Dato"
          value={date}
          onChange={(newValue) => setDate(newValue)}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
      </LocalizationProvider>
    </Grid>
  );
}

export default DateSelector;
